import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslation from "./components/locales/en.json";
import deTranslation from "./components/locales/de.json";

i18n
  .use(LanguageDetector) // Detect user's browser language
  .use(initReactI18next) // Bind i18next to React
  .init({
    resources: {
      en: { translation: enTranslation },
      de: { translation: deTranslation },
    },
    fallbackLng: "en", // Fallback language if detection fails
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["navigator", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;